<div class="lob-model-view">
    <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
        <div class="uitk-c-card uhc-font">
                            <div class="uitk_new_header">
                                <div class="uitk-l-grid__col--12 stk-container-tabl-header">
                                    <div class="stk-header-action row">
                                        <div class="table-header-icons col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
                                            <ng-container *ngIf="dataSourceDetails && dataSourceDetails.data.length">
                                                <div class="table-search col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-6">
                                                    <mat-form-field class="data-filter" appearance="outline" style="padding: 0px;">
                                                        <input [(ngModel)]="searchField" matInput type="text"
                                                            class="capability-search"
                                                            placeholder="Search MBO Segment ID/MBO Segment/MBO Owner"
                                                            (keyup)="searchDataSet($event)">
                                                        <img src="../../../../assets/images/searchicon.png" class="lob-view-search-img"/>
                                                    </mat-form-field>
                                                </div>
                                            </ng-container> 
                                            &nbsp;
                                            <div class="table-header-icons table-header-icons-buttons col-md-8 col-sm-6 col-lg-8 col-xl-8 col-xs-6">
                                                <ng-container *ngIf="dataSourceDetails && dataSourceDetails.data.length"> 
                                                    <button (click)="expandAllFunc()" class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs">{{allRowsExpanded ? 'Collapse All' : 'Expand All'}}</button>
                                                </ng-container>
                                                 &nbsp;
                                                <div *ngIf="dataSourceDetails && dataSourceDetails.data.length"
                                                    (click)="exportToCsv()" class="export-link">
                                                    <span title="Click to Download" class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"></span>
                                                </div>
                                            </div>
                                        </div>    
                                    </div>
                                </div>
                            </div>
                            <div class="uitk-c-card__content" style="margin-top: 0px !important;">
                                <div class="stk-table-container">
                                    <div class="stk-table-loader" *ngIf="showLoader">
                                        <app-loader>
                                        </app-loader>
                                    </div>
                                    <div class="stk-table-loader partial-loader" *ngIf="partialLoader">
                                        <app-loader>
                                        </app-loader>
                                    </div>
                                    <div class="stk-table-loader lob-loader" *ngIf="lobLoader">
                                        <app-loader>
                                        </app-loader>
                                    </div>                                                
                                    <ng-container *ngIf="!showLoader">
                                        <app-maintenance-table-v4 [TABLE_CONFIG]="TABLE_CONFIG" [COLUMNS]="TABLE_COLUMNS"
                                            [expanded_columns]="expanded_columns" (reloadData)="handleAppicationload()"
                                            [SORT_CONFIG]="sortConfig" [dataSource]="dataSourceDetails"
                                            [childDataSource]="dataSourceDetails"
                                            [SCHEMA]="DATA_SCHEMA" 
                                            (searchEvent)="searchEvent($event)"
                                            (checkBoxEvent)="checkBoxEvent($event)"
                                            [pageSize]="TABLE_CONFIG.pageSize" [pageIndex]="TABLE_CONFIG.pageIndex" 
                                            [expandAll]="expandAll" [exportToExcel]="exportToExcel"
                                            [selectedOption]="selectedOption"
                                            (collapseAll)="collapseAllFunc($event)"
                                            [dataSourceDecomLOBSegments]="olddatasource"
                                            (getLobMappingDetails)="refreshDecomDetailsTable()"
                                            >
                                        </app-maintenance-table-v4>
                                    </ng-container>
                                </div>
                            </div>
        </div>
    </div>
</div>
